import React from "react";
import { Box, Text } from "@saleor/macaw-ui-next";

interface VendorDetailsProps {
  id: string;
  params: any;
}

const VendorDetailsView: React.FC<VendorDetailsProps> = ({ id }) => {
  return (
    <Box padding={6}>
      <Text>Vendor Details Page - ID: {id}</Text>
      <Text>This page is under development.</Text>
    </Box>
  );
};

export default VendorDetailsView;